import get from 'lodash.get';

export const selectArticle = (state) => get(state, 'article');

export const selectArticleData = (state) => get(state, 'article.data');
